import React from "react";
import { TextField } from "@mui/material";
import GroupAllUsers from "../FieldTags/GroupAllUsers";
import xplanLabels from "../../util/XplanLabels";
import HistoryLogElement from "./HistoryLogElement";

const newPlan = window.location.pathname === "/xplans/new";

const GeneralComment = ({ generalComment, handleChange, xplans }) => {
    return (
        <div id="generalComment" className="planField">
            <GroupAllUsers />
            <TextField
                name="generalComment"
                label={xplanLabels.generalComment}
                InputLabelProps={{ shrink: true }}
                type="text"
                value={generalComment ? generalComment : ""}
                onChange={(e) => handleChange("generalComment", e.target.value)}
                multiline
                minRows={1}
                className="fullLength"
            />
            {!newPlan && <HistoryLogElement xplans={xplans} label={"generalComment"} />}
        </div>
    );
};

export default GeneralComment;
